import React, {useEffect} from "react";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import Chip from "@mui/material/Chip";

import { isStringEmpty } from "../services/StringService";
import { getPeriodName } from "../services/SchoolService";

const PeriodListItem = ({ school, period, periodNumber, onClick }) => {
  useEffect(() => {
    console.log(period);
  }, []);


  const getProctorName = (activity) => {
    if (activity.proctor) {
      return activity.proctor;
    }

    if (activity.last_name) {
      return activity.last_name + ", " + activity.first_name.charAt(0);
    }

    return "None"
  };

  const handlePeriodClick = (period) => {
    if (!onClick) {
      return;
    }
    onClick(period);
  };

  return (
    <ListItem
      key={period}
      alignItems="flex-start"
      onClick={() => handlePeriodClick(period)}
      sx={{ cursor: onClick != null ? "pointer" : "", pt: 0, pb: 0 }}
    >
      {!isStringEmpty(period.activityDateEid) && (
        <>
          <ListItemAvatar>
            <Avatar
              alt={school.activityPrefix + " " + periodNumber}
              src={`https://alltimely-public.s3.amazonaws.com/global/image/icons/${period.iconPath}`}
            />
          </ListItemAvatar>
          <ListItemText
            primary={getPeriodName(school, periodNumber - 1)}
            secondary={
              <>
                <span style={{ display: "inline", color: "black" }}>
                  {period.name}
                </span>
                <br />
                <span>
                  {getProctorName(period)} @ <strong>{period.location}</strong>
                </span>
                <span style={{ fontStyle: "italic" }}>
                  {!isStringEmpty(period.description) && (
                    <>
                      <br />
                      Desc: 
                      <span dangerouslySetInnerHTML={{ __html: period.description }}></span>
                    </>
                  )}
                  {!isStringEmpty(period.activityDateDescription) && (
                    <>
                      <br />
                      Desc: 
                      <span dangerouslySetInnerHTML={{ __html: period.activityDateDescription }}></span>
                    </>
                  )}
                </span>
                {period.tags && period.tags.length > 0 && (
                  <div>
                    {period.tags.map((tag) => (
                      <Chip label={tag.name} sx={{mr:0.5}} color="success" />
                    ))}
                  </div>
                )}
              </>
            }
          />
        </>
      )}
      {isStringEmpty(period.activityDateEid) && (
        <>
          <ListItemAvatar>
            <Avatar
              alt={school.activityPrefix + " " + periodNumber}
              src={`https://alltimely-public.s3.amazonaws.com/global/image/icons/arrows/Image-45.png`}
            />
          </ListItemAvatar>
          <ListItemText
            primary={getPeriodName(school, periodNumber - 1)}
            secondary="None Selected"
          />
        </>
      )}
    </ListItem>
  );
};

export default PeriodListItem;
